// // SearchInput.jsx
// import { memo, useEffect, useRef } from "react";

// const SearchInput = memo(({ value, onChange, placeholder = "Type to search..." }) => {
//   const inputRef = useRef(null);
//   const caretRef = useRef({ start: null, end: null, hadFocus: false });

//   const handleChange = (e) => {
//     caretRef.current.start = e.target.selectionStart;
//     caretRef.current.end = e.target.selectionEnd;
//     caretRef.current.hadFocus = document.activeElement === e.target;
//     onChange(e.target.value, 1);
//   };

//   useEffect(() => {
//     const { hadFocus, start, end } = caretRef.current;
//     if (hadFocus && inputRef.current) {
//       inputRef.current.focus({ preventScroll: true });
//       try {
//         if (start != null && end != null) {
//           inputRef.current.setSelectionRange(start, end);
//         }
//       } catch { }
//     }
//   });

//   return (
//     <div className="search-input-wrapper">
//       <div className="search-input-container position-relative d-flex align-items-center">
//         <div className="search-input-icon-wrapper position-absolute d-flex align-items-center justify-content-center">
//           <i className="bi bi-search search-input-icon"></i>
//         </div>
//         <input
//           ref={inputRef}
//           type="text"
//           value={value}
//           onChange={handleChange}
//           className="search-input-field"
//           placeholder={placeholder}
//         />
//         {value && (
//           <button
//             type="button"
//             className="search-input-clear-btn position-absolute d-flex align-items-center justify-content-center border-0 bg-transparent"
//             onClick={() => onChange("", 1)}
//             aria-label="Clear search"
//           >
//             <i className="bi bi-x search-input-clear-icon"></i>
//           </button>
//         )}
//       </div>
//     </div>
//   );
// });

// export default SearchInput;





import { memo, useEffect, useRef } from "react";

const SearchInput = memo(({ value, onChange, placeholder = "Type to search..." }) => {
  const inputRef = useRef(null);
  const caretRef = useRef({ start: null, end: null, hadFocus: false });

  const handleChange = (e) => {
    caretRef.current.start = e.target.selectionStart;
    caretRef.current.end = e.target.selectionEnd;
    caretRef.current.hadFocus = document.activeElement === e.target;
    onChange(e.target.value, 1);
  };

  useEffect(() => {
    const { hadFocus, start, end } = caretRef.current;
    if (hadFocus && inputRef.current) {
      inputRef.current.focus({ preventScroll: true });
      try {
        if (start != null && end != null) {
          inputRef.current.setSelectionRange(start, end);
        }
      } catch {}
    }
  });

  return (
    <div className="search-input-wrapper">
      <div className="search-input-container position-relative d-flex align-items-center">
        <div className="search-input-icon-wrapper position-absolute d-flex align-items-center justify-content-center">
          <i className="bi bi-search search-input-icon"></i>
        </div>

        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={handleChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }}
          className="search-input-field"
          placeholder={placeholder}
        />

        {value && (
          <button
            type="button"
            className="search-input-clear-btn position-absolute d-flex align-items-center justify-content-center border-0 bg-transparent"
            onClick={() => onChange("", 1)}
            aria-label="Clear search"
          >
            <i className="bi bi-x search-input-clear-icon"></i>
          </button>
        )}
      </div>
    </div>
  );
});

export default SearchInput;
